import React, { useRef, useState } from "react";
import styles from "./Search.module.css";
import { ReactComponent as SearchIcon } from "../assests/SearchIcon.svg"
import { useAutocomplete } from "@mui/base/useAutocomplete";
import { styled } from "@mui/system";
// import { truncate } from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";



const Listbox = styled("ul")(({ theme }) => ({
  width: "100%",
  margin: 0,
  padding: 0,
  position: "absolute",
  borderRadius: "0px 0px 10px 10px",
  border: "1px solid #34C94B",
  top: 60,
  height: "max-content",
  maxHeight: "500px",
  zIndex: 10,
  overflowY: "scroll",
  left: 0,
  bottom: 0,
  right: 0,
  listStyle: "none",
  backgroundColor: "#121212",
  overflow: "auto",
  color: "white",
  "& li.Mui-focused": {
    backgroundColor: "#4a8df6",
    color: "white",
    cursor: "pointer",
  },
  "& li:active": {
    backgroundColor: "#2977f5",
    color: "white",
  },
}));

function Search({ searchData, placeholder }) {

const [inputValue, setInputValue] = useState("");
  const {
    getRootProps,
    getInputLabelProps,
    value,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    id: "use-autocomplete-demo",
    options: searchData || [],
    getOptionLabel: (option) => option.title, 
  });

  const navigate = useNavigate();
  

  const onSubmit = (e, value) => {
    e.preventDefault();
    setInputValue("");
    navigate(`/AlbumDetail/:${value.id}`);
    Autocomplete.value = "";
    //Process form data, call API, set state etc.
  };

  const handleChange = (e)=>{
    setInputValue(e.target.value)
  }

 
  
  // console.log("Search component rendered")
  return (
    <div style={{ position: "relative" }} >
      <form
        className={styles.wrapper}
        onSubmit={(e) => {
          onSubmit(e, value);
        }}
      >
        <div {...getRootProps()}  >
          <input
            name="album"
            className={styles.search}
            placeholder={placeholder}
            required
            value={inputValue}
            onChange={(e)=>handleChange(e)}
            {...getInputProps()}
          />
        </div>
        <div >
          <button className={styles.searchButton} type="submit">
            <SearchIcon />
          </button>
        </div>
      </form>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => {
            // console.log(option);
            const artists = option.songs.reduce((accumulator, currentValue) => {
              accumulator.push(...currentValue.artists);
              return accumulator;
            }, []);

            return (
              <li
                className={styles.listElement}
                {...getOptionProps({ option, index })}
              >
                <img src={option.image} className={styles.optionImage}></img>
                <div style={{alignContent: "center"}}>
                  <p className={styles.albumTitle}>{option.title}</p>

                  <p className={styles.albumArtists}>
                    {/* {truncate(artists.join(", "), 40)} */}
                    {artists[0]}
                  </p>
                </div>
                <div style={{display: "flex", flexWrap: "wrap", alignContent: "center"}}>{option.follows} Follows</div>
              
              </li>
            );
          })}
        </Listbox>
      ) : null}
    </div>
    
  );
}

export default Search;
